module.exports = __webpack_public_path__ + "img/step-02-settings.34f61ea8.svg";